import { useEffect, useRef, useState } from 'react';

export const useTableHeight = (deps: {
  columnsCount: number;
  examplesCount?: number;
  isTextTruncated: boolean;
  hideMetrics: boolean;
}) => {
  const tableRef = useRef<HTMLDivElement>(null);

  const [tableHeight, setTableHeight] = useState(0);

  useEffect(() => {
    if (tableRef.current) {
      setTableHeight(tableRef.current.clientHeight - 3);
    }
    // set a timeout because of the animation
    const timer = setTimeout(() => {
      if (tableRef.current) {
        setTableHeight(tableRef.current.clientHeight - 3);
      }
    }, 200);

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === tableRef.current) {
          setTableHeight(entry.target.clientHeight - 3);
        }
      }
    });

    if (tableRef.current) {
      resizeObserver.observe(tableRef.current);
    }

    const handleWindowResize = () => {
      if (tableRef.current) {
        setTableHeight(tableRef.current.clientHeight - 3);
      }
    };

    window.addEventListener('resize', handleWindowResize);
    return () => {
      clearTimeout(timer);
      resizeObserver.disconnect();
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [
    deps.columnsCount,
    deps.examplesCount,
    deps.isTextTruncated,
    deps.hideMetrics,
  ]);

  return { tableHeight, tableRef };
};
